var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.6 5c0-.22.18-.4.4-.4h6.383a.4.4 0 0 1 .325.167l2.854 3.987h8.239a.4.4 0 0 1 .4.4v10.684a.4.4 0 0 1-.4.4H3a.4.4 0 0 1-.4-.4zm.8.4v14.038h17V9.554h-8.043a.4.4 0 0 1-.325-.167L9.177 5.4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.375 7.145a.23.23 0 0 0-.232.232v1.187c0 .128.104.232.232.232H7.75a.23.23 0 0 0 .232-.232V7.377a.23.23 0 0 0-.232-.232zM5 13.4c0-.22.11-.4.246-.4h4.308c.136 0 .246.18.246.4s-.11.4-.246.4H5.246c-.136 0-.246-.18-.246-.4m0 2c0-.22.22-.4.492-.4h8.616c.272 0 .492.18.492.4s-.22.4-.492.4H5.492c-.272 0-.492-.18-.492-.4",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgProjects);
export default __webpack_public_path__ + "static/media/org-projects.0cc2447596514bf61dc006b60f3e23ad.svg";
export { ForwardRef as ReactComponent };